import { render, staticRenderFns } from "./traceability.vue?vue&type=template&id=39ff02f3&scoped=true&"
import script from "./traceability.vue?vue&type=script&lang=js&"
export * from "./traceability.vue?vue&type=script&lang=js&"
import style0 from "./traceability.vue?vue&type=style&index=0&id=39ff02f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ff02f3",
  null
  
)

export default component.exports